import api from '@/services/api';

/**
 * Retrieve a list of code nafs
 * @param {String} term
 * @returns {[CodeNafs]} a list of results
 */
const findCodeNafsByTerm = (term) => api().get(`codenafs/autocomplete/${term}`);

export {
  // eslint-disable-next-line import/prefer-default-export
  findCodeNafsByTerm,
};
